/**
 * @typedef {Object} Aposta
 * @property {number} code
 * @property {number} value
 * @property {string} date
 * @property {{
 *      game: {
 *          type: number,
 *          name: string
 *      },
 *      value: number,
 *      numbers: string[]
 * }[]} bets
 */

import moment from "moment";

/**
 * @returns {Aposta[]}
 */
export function getFiltredApostaSimples(vchGuidPreValidacao) {
    let localapostas = [];
    if(localStorage && localStorage.getItem("saved-apostas-simples")){
        localapostas = getApostasSimples();
        localapostas = localapostas.filter(aposta=>{
            const apostaHora = aposta.bilhetes[0].date.split(',')[1];
            const convertedApostaHora = moment(apostaHora, "HH:mm:ss");
            const convertedNow = moment();
            const dateDiff = convertedNow.diff(convertedApostaHora, 'hours');
            return dateDiff < 1;
        });
    }
    return localapostas || [];
}

export function getApostasSimples() {
    if(localStorage && localStorage.getItem("saved-apostas-simples")) return JSON.parse(localStorage.getItem("saved-apostas-simples"));
    return [];
}

/**
 * @param {Aposta[]} newList
 */
export function setApostasSimples(newList) {
    if(localStorage) localStorage.setItem("saved-apostas-simples", JSON.stringify(newList));
}

export function saveApostaSimples(newAposta) {
    if(getFiltredApostaSimples(newAposta.vchGuidPreValidacao).length <= 0){
        const newList = getApostasSimples() || [];
        newList.unshift(newAposta);
        return setApostasSimples(newList);
    }
}

export function clearApostasSimples() {
    return setApostasSimples([]);
}

export function deleteApostaSimples(guid) {
    const newList = getApostasSimples();
    if (!newList) return;

    const index = newList.findIndex(({ GUID }) => GUID === guid);
    newList.splice(index, 1);
    return setApostasSimples(newList);
}


// WEBPACK FOOTER //
// ./src/utils/getApostasSimples.js